import { get, put, post } from 'Api';
import store from 'Redux/store';

// router.post('/user/payment/forget'
// router.get('/user/payment/methods'
// router.post('/user/payment/methods'
// router.put('/user/payment/methods/:id'

export function getMethods() {
  return get(store.dispatch, '/user/payment/methods');
}

export function removeMethod(id) {
  return post(store.dispatch, '/user/payment/forget', { recurringDetailReference: id });
}

export function saveMethod(paymentDetails, deviceFingerprint, shopperLocale, browserInfo) {
  return post(store.dispatch, '/user/payment/methods', { paymentDetails, deviceFingerprint, shopperLocale, browserInfo });
}

export function setPrimary(id) {
  return put(store.dispatch, `/user/payment/methods/${id}`);
}
